import { useState, useMemo, useCallback } from 'react';
import './ToolStyles.css';

const TextDedup = () => {
    const [text, setText] = useState('');
    const [copied, setCopied] = useState(false);

    const { result, stats } = useMemo(() => {
        if (!text) {
            return { result: '', stats: null };
        }

        // 按行拆分
        const rawLines = text.split('\n');

        // trim 每行首尾空白（空格、制表符等）
        const trimmedLines = rawLines.map((line) => line.trim());

        // 过滤空行
        const nonEmptyLines = trimmedLines.filter((line) => line !== '');

        // 去重
        const uniqueLines = [...new Set(nonEmptyLines)];

        // 升序排序（支持中英文混合）
        uniqueLines.sort((a, b) => a.localeCompare(b, 'zh-CN'));

        const result = uniqueLines.join('\n');

        const stats = {
            rawCount: rawLines.length,
            dedupedCount: uniqueLines.length,
            removedCount: rawLines.length - uniqueLines.length,
        };

        return { result, stats };
    }, [text]);

    const handleCopy = useCallback(async () => {
        if (!result) return;
        try {
            await navigator.clipboard.writeText(result);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // 降级方案：使用传统方法复制
            const textarea = document.createElement('textarea');
            textarea.value = result;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    }, [result]);

    return (
        <div className="tool-container">
            <div className="dedup-layout">
                {/* 左侧：输入 + 统计 */}
                <div className="dedup-left">
                    <div className="input-group">
                        <label className="input-label">📝 输入文本</label>
                        <textarea
                            className="tool-textarea"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows={12}
                            placeholder="输入或粘贴多行文本，自动去重排序..."
                            style={{ resize: 'vertical', minHeight: '200px' }}
                        />
                    </div>

                    {stats && (
                        <div className="timestamp-grid">
                            <div className="timestamp-item">
                                <span className="timestamp-label">原始行数</span>
                                <span className="timestamp-value">{stats.rawCount}</span>
                            </div>
                            <div className="timestamp-item">
                                <span className="timestamp-label">去重后行数</span>
                                <span className="timestamp-value">{stats.dedupedCount}</span>
                            </div>
                            <div className="timestamp-item">
                                <span className="timestamp-label">移除重复/空行</span>
                                <span className="timestamp-value">{stats.removedCount}</span>
                            </div>
                        </div>
                    )}
                </div>

                {/* 右侧：去重结果 */}
                <div className="dedup-right">
                    <div className="output-group" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className="output-header">
                            <label className="output-label">📤 去重结果</label>
                            <button className="copy-button" onClick={handleCopy}>
                                {copied ? '✅ 已复制' : '📋 复制'}
                            </button>
                        </div>
                        <pre className="tool-output code" style={{ minHeight: '200px' }}>
                            {result || ' '}
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TextDedup;
